import { HTTP } from "@/common/http-common";

const RESOURCE_NAME = "entities/studentLevels";

export default {
  async save(entity) {
    return (await HTTP.post(`${RESOURCE_NAME}`, entity)).data;
  },
};
